<ui-card
    [loading]="loading"
    [cardTitle]="title"
    variant="default"
    display="full-space"
    shape="square"
    class="ui-checklist"
>
    <ui-button
        card-action
        variant="outline"
        (click)="goToPrevious()"
        [disabled]="selectedCampoIndex === 0 || loading"
    >
        <i class="fa fa-arrow-left"></i>
    </ui-button>
    <ui-button
        card-action
        variant="outline"
        (click)="goToNext()"
        [disabled]="selectedCampoIndex >= grupos.length - 1 || loading"
    >
        <i class="fa fa-arrow-right"></i>
    </ui-button>
    <ui-button
        card-action
        [disabled]="handleSaveButtonDisabled() || loading"
        (click)="handleSave()"
    >
        <i class="fa fa-save"></i> Salvar
    </ui-button>

    @if (!loading) {
        <div class="ui-checklist__container">
            <div class="ui-checklist__sidebar-wrapper">
                <div class="ui-checklist__sidebar">
                    @if (title) {
                        <div class="h-16px"></div>
                    }
                    @for (grupo of grupos; track grupo.id; let c = $index) {
                        <a class="ui-checklist__sidebar-item"
                           [ngClass]="{'ui-checklist__sidebar-item-selected': grupo?.selected}"
                           (click)="selectGroup(grupo, c)">
                            {{ grupo.titulo }}
                        </a>
                    }
                </div>
            </div>

            <div class="ui-checklist__content">
                <ui-checklist-group
                    [(preenchimento)]="filteredPreenchimento"
                    [(formCondicionais)]="preenchimentosCondicional"
                    [isEdit]="edit"
                    [arquivos]="arquivos"
                ></ui-checklist-group>
            </div>
        </div>

        <ui-modal>
            <h3 modalTitle>Campos sem Preenchimentos</h3>
            <h4 modalSubtitle>Os seguintes campos precisam ser preenchidos antes de continuar</h4>
            <ui-card
                modalContent
                shape="square"
            >
                <table ui-table
                       [loading]="loading"
                       [empty]="invalidItems?.length === 0"
                >
                    @for (campo of invalidItems; track campo) {
                        <thead>
                        <tr class="text-left" style="    border-top: 1px solid var(--brand-primary-dark);
        border-bottom: 1px solid var(--brand-primary-dark);">
                            <th class="text-brand-primary-darkest"><strong>{{ campo.titulo }}</strong>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                            @for (question of campo.nome; track question) {
                                <tr>
                                    <td class="text-left">{{ question }}</td>
                                </tr>
                            }
                        </tbody>
                    }
                </table>
            </ui-card>
            <ui-button
                modalAction
                variant="outline"
                modal-toggle
                width="full-space"
            >
                Fechar
            </ui-button>
        </ui-modal>
    }
</ui-card>

